import React from "react";
import { Layout } from "antd";
import foxitLogo from "./img/foxit.svg";
const { Header, Content } = Layout;

class BasicLayout extends React.Component {
  render() {
    return (
      <Layout style={{ background: "#ffffff" }}>
        <Header className="tools-main-layout-header">
          <div className="header-logo-container">
            <img className="logo-img" src={foxitLogo} alt=""></img>
          </div>
        </Header>
        <Content
          className="tools-main-layout-content"
          // style={{ margin: "24px 16px 0" }}
        >
          {this.props.children}
        </Content>
      </Layout>
    );
  }
}

export default BasicLayout;
